import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index'

var eraValues = {
  abbreviated: ['BC', 'AD'],
  narrow: ['BC', 'AD'],
  wide: ['Sa Wala Pa Si Kristo', 'Anno Domini']
}

var quarterValues = {
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  narrow: ['1', '2', '3', '4'],
  wide: [
    'unang quarter',
    'ika-2 nga quarter',
    'ika-3 nga quarter',
    'ika-4 nga quarter'
  ]
}

var formattingQuarterValues = quarterValues

var monthValues = {
  abbreviated: [
    'Ene',
    'Peb',
    'Mar',
    'Abr',
    'May',
    'Hun',
    'Hul',
    'Ago',
    'Set',
    'Okt',
    'Nob',
    'Dis'
  ],
  narrow: ['E', 'P', 'M', 'A', 'M', 'H', 'H', 'A', 'S', 'O', 'N', 'D'],
  wide: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre'
  ]
}

var formattingMonthValues = monthValues

var dayValues = {
  abbreviated: ['Dom', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  narrow: ['D', 'L', 'M', 'M', 'H', 'B', 'S'],
  short: ['Dom', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  wide: [
    'Domingo',
    'Lunes',
    'Martes',
    'Miyerkules',
    'Huwebes',
    'Biyernes',
    'Sabado'
  ]
}

var formattingDayValues = dayValues

var dayPeriodValues = {
  abbreviated: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  },
  narrow: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  },
  wide: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  }
}

var formattingDayPeriodValues = {
  abbreviated: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  },
  narrow: {
    afternoon: undefined,
    am: 'a',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'p'
  },
  wide: {
    afternoon: undefined,
    am: 'AM',
    evening: undefined,
    midnight: undefined,
    morning: undefined,
    night: undefined,
    noon: undefined,
    pm: 'PM'
  }
}

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  return dirtyNumber
}

var localize = {
  ordinalNumber: ordinalNumber,

  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),

  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    argumentCallback: function(quarter) {
      return Number(quarter) - 1
    }
  }),

  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),

  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),

  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
}

export default localize
